export const adminUser = {
    id: 123,
    first_name: 'Wanda',
    middle_name: null,
    last_name: 'Maximoff',
    title: null,
    email_address: 'scarlet.witch@avengers.com',
    phone_number: null,
    active_till: null,
    business_id: null,
    disabled: null,
    deleted: false,
    created_at: '2017-10-18T16:41:05.000Z',
    updated_at: '2018-12-11T19:07:49.000Z',
    user_type: 'lender',
    flow_step: null,
    traffic_ip: null,
    traffic_user_agent: null,
    landing_page_referrer: null,
    is_sales_person: null,
    reset_password_required: null,
    is_underwriter: null,
    is_admin: true,
    is_operations: false,
    archived: false,
    business_abl_id: null,
    uuid: null,
    permissions: [
        {
            id: 67,
            role_id: null,
            object_type: 'Business',
            enabled: true,
            created_at: '2022-10-13T16:04:49.781Z',
            updated_at: '2022-10-13T16:04:49.781Z',
            action: 'update',
            name: 'Update Business permission',
        },
        {
            id: 68,
            role_id: null,
            object_type: 'Business',
            enabled: true,
            created_at: '2022-10-13T16:04:50.264Z',
            updated_at: '2022-10-13T16:04:50.264Z',
            action: 'read',
            name: 'Read Business permission',
        },
        {
            id: 69,
            role_id: null,
            object_type: 'Business',
            enabled: true,
            created_at: '2022-10-13T16:04:50.746Z',
            updated_at: '2022-10-13T16:04:50.746Z',
            action: 'destroy',
            name: 'Destroy Business permission',
        },
        {
            id: 82,
            role_id: null,
            object_type: 'Ledger::Accounts::TenantSetting',
            enabled: true,
            created_at: '2022-10-13T16:04:57.019Z',
            updated_at: '2022-10-13T16:04:57.019Z',
            action: 'update',
            name: 'Update Ledger Accounts',
        },
        {
            id: 83,
            role_id: null,
            object_type: 'Ledger::Accounts::TenantSetting',
            enabled: true,
            created_at: '2022-10-13T16:04:57.495Z',
            updated_at: '2022-10-13T16:04:57.495Z',
            action: 'create',
            name: 'Create Ledger Accounts',
        },
        {
            id: 84,
            role_id: null,
            object_type: 'lender_home',
            enabled: true,
            created_at: '2022-10-13T16:04:57.976Z',
            updated_at: '2022-10-13T16:04:57.976Z',
            action: 'view',
            name: 'View Lender Home',
        },
        {
            id: 85,
            role_id: null,
            object_type: 'e-signing',
            enabled: true,
            created_at: '2022-10-13T16:04:58.466Z',
            updated_at: '2022-10-13T16:04:58.466Z',
            action: 'view',
            name: 'View E-signing',
        },
        {
            id: 86,
            role_id: null,
            object_type: 'brokers',
            enabled: true,
            created_at: '2022-10-13T16:04:58.947Z',
            updated_at: '2022-10-13T16:04:58.947Z',
            action: 'view',
            name: 'View Brokers',
        },
        {
            id: 70,
            role_id: null,
            object_type: 'CollectionsCheck',
            enabled: true,
            created_at: '2022-10-13T16:04:51.237Z',
            updated_at: '2022-10-13T16:04:51.237Z',
            action: 'update',
            name: 'Update Collections permission',
        },
        {
            id: 71,
            role_id: null,
            object_type: 'Deal',
            enabled: true,
            created_at: '2022-10-13T16:04:51.719Z',
            updated_at: '2022-10-13T16:04:51.719Z',
            action: 'read',
            name: 'Read Deal permission',
        },
        {
            id: 72,
            role_id: null,
            object_type: 'Deal',
            enabled: true,
            created_at: '2022-10-13T16:04:52.205Z',
            updated_at: '2022-10-13T16:04:52.205Z',
            action: 'update',
            name: 'Update Deal permission',
        },
        {
            id: 73,
            role_id: null,
            object_type: 'FundingRequest',
            enabled: true,
            created_at: '2022-10-13T16:04:52.688Z',
            updated_at: '2022-10-13T16:04:52.688Z',
            action: 'read',
            name: 'Read Funding Request permission',
        },
        {
            id: 74,
            role_id: null,
            object_type: 'FundingRequest',
            enabled: true,
            created_at: '2022-10-13T16:04:53.168Z',
            updated_at: '2022-10-13T16:04:53.168Z',
            action: 'update',
            name: 'Update Funding Request permission',
        },
        {
            id: 75,
            role_id: null,
            object_type: 'FundingRequest',
            enabled: true,
            created_at: '2022-10-13T16:04:53.654Z',
            updated_at: '2022-10-13T16:04:53.654Z',
            action: 'destroy',
            name: 'Destroy Funding Request permission',
        },
        {
            id: 76,
            role_id: null,
            object_type: 'Invoice',
            enabled: true,
            created_at: '2022-10-13T16:04:54.136Z',
            updated_at: '2022-10-13T16:04:54.136Z',
            action: 'read',
            name: 'Read Invoice permission',
        },
        {
            id: 77,
            role_id: null,
            object_type: 'Invoice',
            enabled: true,
            created_at: '2022-10-13T16:04:54.615Z',
            updated_at: '2022-10-13T16:04:54.615Z',
            action: 'update',
            name: 'Update Invoice permission',
        },
        {
            id: 78,
            role_id: null,
            object_type: 'Invoice',
            enabled: true,
            created_at: '2022-10-13T16:04:55.103Z',
            updated_at: '2022-10-13T16:04:55.103Z',
            action: 'destroy',
            name: 'Destroy Invoice permission',
        },
        {
            id: 79,
            role_id: null,
            object_type: 'InvoiceChargeback',
            enabled: true,
            created_at: '2022-10-13T16:04:55.591Z',
            updated_at: '2022-10-13T16:04:55.591Z',
            action: 'update',
            name: 'Update Invoice Chargeback permission',
        },
        {
            id: 80,
            role_id: null,
            object_type: 'InvoiceSchedule',
            enabled: true,
            created_at: '2022-10-13T16:04:56.057Z',
            updated_at: '2022-10-13T16:04:56.057Z',
            action: 'read',
            name: 'Update Invoice Schedule permission',
        },
        {
            id: 81,
            role_id: null,
            object_type: 'VerificationType',
            enabled: true,
            created_at: '2022-10-13T16:04:56.535Z',
            updated_at: '2022-10-13T16:04:56.535Z',
            action: 'read',
            name: 'Read Verification permission',
        },
    ],
};
export const salespersonUser = {
    id: 456,
    first_name: 'Bruce',
    middle_name: null,
    last_name: 'Banner',
    title: null,
    email_address: 'hulk@avengers.com',
    phone_number: null,
    active_till: null,
    business_id: null,
    disabled: null,
    deleted: false,
    created_at: '2017-10-18T16:41:05.000Z',
    updated_at: '2018-12-11T19:07:49.000Z',
    user_type: 'lender',
    flow_step: null,
    traffic_ip: null,
    traffic_user_agent: null,
    landing_page_referrer: null,
    is_sales_person: true,
    reset_password_required: null,
    is_underwriter: null,
    is_admin: false,
    is_operations: false,
    archived: false,
    business_abl_id: null,
    uuid: null,
    permissions: [
        {
            id: 67,
            role_id: null,
            object_type: 'Business',
            enabled: true,
            created_at: '2022-10-13T16:04:49.781Z',
            updated_at: '2022-10-13T16:04:49.781Z',
            action: 'update',
            name: 'Update Business permission',
        },
        {
            id: 68,
            role_id: null,
            object_type: 'Business',
            enabled: true,
            created_at: '2022-10-13T16:04:50.264Z',
            updated_at: '2022-10-13T16:04:50.264Z',
            action: 'read',
            name: 'Read Business permission',
        },
        {
            id: 69,
            role_id: null,
            object_type: 'Business',
            enabled: true,
            created_at: '2022-10-13T16:04:50.746Z',
            updated_at: '2022-10-13T16:04:50.746Z',
            action: 'destroy',
            name: 'Destroy Business permission',
        },
        {
            id: 82,
            role_id: null,
            object_type: 'Ledger::Accounts::TenantSetting',
            enabled: true,
            created_at: '2022-10-13T16:04:57.019Z',
            updated_at: '2022-10-13T16:04:57.019Z',
            action: 'update',
            name: 'Update Ledger Accounts',
        },
        {
            id: 83,
            role_id: null,
            object_type: 'Ledger::Accounts::TenantSetting',
            enabled: true,
            created_at: '2022-10-13T16:04:57.495Z',
            updated_at: '2022-10-13T16:04:57.495Z',
            action: 'create',
            name: 'Create Ledger Accounts',
        },
        {
            id: 84,
            role_id: null,
            object_type: 'lender_home',
            enabled: true,
            created_at: '2022-10-13T16:04:57.976Z',
            updated_at: '2022-10-13T16:04:57.976Z',
            action: 'view',
            name: 'View Lender Home',
        },
        {
            id: 85,
            role_id: null,
            object_type: 'e-signing',
            enabled: true,
            created_at: '2022-10-13T16:04:58.466Z',
            updated_at: '2022-10-13T16:04:58.466Z',
            action: 'view',
            name: 'View E-signing',
        },
        {
            id: 86,
            role_id: null,
            object_type: 'brokers',
            enabled: true,
            created_at: '2022-10-13T16:04:58.947Z',
            updated_at: '2022-10-13T16:04:58.947Z',
            action: 'view',
            name: 'View Brokers',
        },
        {
            id: 70,
            role_id: null,
            object_type: 'CollectionsCheck',
            enabled: true,
            created_at: '2022-10-13T16:04:51.237Z',
            updated_at: '2022-10-13T16:04:51.237Z',
            action: 'update',
            name: 'Update Collections permission',
        },
        {
            id: 71,
            role_id: null,
            object_type: 'Deal',
            enabled: true,
            created_at: '2022-10-13T16:04:51.719Z',
            updated_at: '2022-10-13T16:04:51.719Z',
            action: 'read',
            name: 'Read Deal permission',
        },
        {
            id: 72,
            role_id: null,
            object_type: 'Deal',
            enabled: true,
            created_at: '2022-10-13T16:04:52.205Z',
            updated_at: '2022-10-13T16:04:52.205Z',
            action: 'update',
            name: 'Update Deal permission',
        },
        {
            id: 73,
            role_id: null,
            object_type: 'FundingRequest',
            enabled: true,
            created_at: '2022-10-13T16:04:52.688Z',
            updated_at: '2022-10-13T16:04:52.688Z',
            action: 'read',
            name: 'Read Funding Request permission',
        },
        {
            id: 74,
            role_id: null,
            object_type: 'FundingRequest',
            enabled: true,
            created_at: '2022-10-13T16:04:53.168Z',
            updated_at: '2022-10-13T16:04:53.168Z',
            action: 'update',
            name: 'Update Funding Request permission',
        },
        {
            id: 75,
            role_id: null,
            object_type: 'FundingRequest',
            enabled: true,
            created_at: '2022-10-13T16:04:53.654Z',
            updated_at: '2022-10-13T16:04:53.654Z',
            action: 'destroy',
            name: 'Destroy Funding Request permission',
        },
        {
            id: 76,
            role_id: null,
            object_type: 'Invoice',
            enabled: true,
            created_at: '2022-10-13T16:04:54.136Z',
            updated_at: '2022-10-13T16:04:54.136Z',
            action: 'read',
            name: 'Read Invoice permission',
        },
        {
            id: 77,
            role_id: null,
            object_type: 'Invoice',
            enabled: true,
            created_at: '2022-10-13T16:04:54.615Z',
            updated_at: '2022-10-13T16:04:54.615Z',
            action: 'update',
            name: 'Update Invoice permission',
        },
        {
            id: 78,
            role_id: null,
            object_type: 'Invoice',
            enabled: true,
            created_at: '2022-10-13T16:04:55.103Z',
            updated_at: '2022-10-13T16:04:55.103Z',
            action: 'destroy',
            name: 'Destroy Invoice permission',
        },
        {
            id: 79,
            role_id: null,
            object_type: 'InvoiceChargeback',
            enabled: true,
            created_at: '2022-10-13T16:04:55.591Z',
            updated_at: '2022-10-13T16:04:55.591Z',
            action: 'update',
            name: 'Update Invoice Chargeback permission',
        },
        {
            id: 80,
            role_id: null,
            object_type: 'InvoiceSchedule',
            enabled: true,
            created_at: '2022-10-13T16:04:56.057Z',
            updated_at: '2022-10-13T16:04:56.057Z',
            action: 'read',
            name: 'Update Invoice Schedule permission',
        },
        {
            id: 81,
            role_id: null,
            object_type: 'VerificationType',
            enabled: true,
            created_at: '2022-10-13T16:04:56.535Z',
            updated_at: '2022-10-13T16:04:56.535Z',
            action: 'read',
            name: 'Read Verification permission',
        },
    ],
};
export const clientUser = {
    active_till: null,
    archived: false,
    business_abl_id: null,
    business_id: 6844,
    created_at: '2023-07-25T23:21:54.000Z',
    deleted: false,
    disabled: null,
    email_address: 'big.bird@sesamest.org',
    first_name: null,
    flow_step: 'skip_invoices_application_submitted',
    id: 8653,
    is_admin: null,
    is_operations: false,
    is_sales_person: null,
    is_underwriter: null,
    landing_page_referrer: 'direct',
    last_name: null,
    middle_name: null,
    permissions: [],
    length: 0,
    phone_number: null,
    reset_password_required: null,
    title: null,
    traffic_ip: null,
    traffic_user_agent: null,
    underwrite_deal_id: null,
    updated_at: '2023-07-25T23:26:25.000Z',
    user_type: 'client',
    uuid: null,
};
export const MOCK_USER_NOTIFICATIONS_DATA = [
    {
        id: 6,
        type: 'past_due_invoices',
        title: 'Past due invoices',
        summary: 'Total past due invoices have increased by 20% in the last 30 days',
        created_at: '2025-05-05T12:00:00.000Z',
        read_at: null,
        params: {
            title: 'Past due invoices',
            summary: 'Total past due invoices have increased by 20% in the last 30 days',
            entity_id: null,
            entity_type: 'business',
        },
    },
    {
        id: 5,
        type: 'nsf_alert',
        title: 'NSF alert',
        summary: 'NSF payments have been posted 5 times in the last 30 days.',
        created_at: '2025-05-05T11:42:00.000Z',
        read_at: null,
        params: {
            title: 'NSF alert',
            summary: 'NSF payments have been posted 5 times in the last 30 days.',
            entity_id: null,
            entity_type: 'business',
        },
    },
    {
        id: 4,
        type: 'sales_decrease',
        title: 'Sales decrease',
        summary: 'Sales for Bogan Group have decreased by 30% over the last 60 days',
        created_at: '2025-05-04T17:00:00.000Z',
        read_at: null,
        params: {
            title: 'Sales decrease',
            summary: 'Sales for Bogan Group have decreased by 30% over the last 60 days',
            entity_id: null,
            entity_type: 'business',
        },
    },
    {
        id: 3,
        type: 'lien_filed',
        title: 'Lien filed',
        summary: 'A new lien has been filed on James Industries for the following assets: Equipment (ie - trailers, trucks, etc), Current inventory (ie - merchandise, etc)',
        created_at: '2025-05-04T15:27:00.000Z',
        read_at: null,
        params: {
            title: 'Lien filed',
            summary: 'A new lien has been filed on James Industries for the following assets: Equipment (ie - trailers, trucks, etc), Current inventory (ie - merchandise, etc)',
            entity_id: null,
            entity_type: 'business',
        },
    },
    {
        id: 2,
        type: 'ucc_expiring',
        title: 'UCC Expiring',
        summary: 'Filing 389264923 for Nolan-Bednar expires on 07-08-2025',
        created_at: '2025-05-03T08:00:00.000Z',
        read_at: '2025-05-03T09:00:00.000Z',
        params: {
            title: 'UCC Expiring',
            summary: 'Filing 389264923 for Nolan-Bednar expires on 07-08-2025',
            entity_id: null,
            entity_type: 'business',
        },
    },
    {
        id: 1,
        type: '941_taxes_due',
        title: '941 Taxes Due',
        summary: '941 filing for Lost Pines Trucking for Q2 has not been received and is now past due.',
        created_at: '2025-03-31T12:00:00.000Z',
        read_at: '2025-03-31T13:00:00.000Z',
        params: {
            title: '941 Taxes Due',
            summary: '941 filing for Lost Pines Trucking for Q2 has not been received and is now past due.',
            entity_id: null,
            entity_type: 'business',
        },
    },
];
